import { render, staticRenderFns } from "./StampLottery.vue?vue&type=template&id=3b882568&scoped=true&"
import script from "./StampLottery.vue?vue&type=script&lang=js&"
export * from "./StampLottery.vue?vue&type=script&lang=js&"
import style0 from "./StampLottery.vue?vue&type=style&index=0&id=3b882568&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b882568",
  null
  
)

export default component.exports